export class ContactConsigneeParams {    
    public RefId: number;
    public ConsigneeId?: number;
    public AddressType: string;
    public AddressHeading: string;
    constructor(
    ) {
        this.RefId = 0;
        this.AddressType = "B";
        this.AddressHeading = "Billing Address";
        
    }
}


export class StoreParams {    
    public StoreId: number;
    public OfficeId?: number;
    public StoreType: String;
    constructor(
    ) {
        this.StoreId = 0;
        this.OfficeId = 0;
        this.StoreType = "Sale";
    }
}




export class SpraValidationAfterSalesAdmin {    
    SrNo?:number
    EmployeeId?:number;
}



export class FileData {
    Purpose:string
    File?:File        
    constructor(
        ) {
            this.Purpose = "";
        }
}


export class UploadFileData extends FileData{
    IsNewRow:boolean
    disable:boolean;
    DownloadFilePath;
    constructor(
        ) {
            super();
            this.IsNewRow = false;
            this.disable = false;
            this.DownloadFilePath = "";
        }
}






export class Shared {
        public static data:any;
}